import apiClient from './apiClient';

// Tüm cinsiyetleri getir
export const getAllGenders = async () => {
  const response = await apiClient.post('/user/GetAllGenders');
  return response.data.Data.Items || [];
};
